module.exports = __webpack_public_path__ + "img/7E.ea3c3d68.png";